import React from "react";
import { Switch, useRouteMatch, Link } from "react-router-dom";
import { useAuth0 } from "../auth/react-auth0-wrapper";
import { Alert } from "reactstrap";
import PrivateRoute from "../components/PrivateRoute";
import EmailsEditor from "../components/EmailsEditor";
import roles from "../auth/roles";
import OrderEditor from "../views/tenant/OrderEditor";
import OrderList from "../views/tenant/OrderList";
import CustomersList from "../views/tenant/CustomerList";
import CustomerEditor from "../views/tenant/CustomerEditor";
import Storage from "../views/tenant/Storage";
import OrderDelivery from "../views/backoffice/OrderDelivery";
import VehicleEditor from "../views/tenant/VehicleEditor";
import ProductList from "../views/tenant/ProductList";
import ProductEditor from "../views/tenant/ProductEditor";
import SalesList from "../views/tenant/SalesList";
import SaleEditor from "../views/tenant/SaleEditor";
import ServicesList from "../views/tenant/ServicesList";
import ServicesEditor from "../views/tenant/ServiceModelEditor";
import SaleDoc from "../views/tenant/SaleDoc"
import { getUrlParameter } from "../utils/history"
import TenantHierarchy from "../views/admin/TenantHierarchy";
import ServiceNotificationEditor from "../views/tenant/ServiceNotificationEditor";
import ServiceNotificationList from "../views/tenant/ServiceNotificationList";
import MarketingEditor from "../views/tenant/MarketingEditor";
import MarketingList from "../views/tenant/MarketingLists";
import TenantDashboard from "../views/admin/TenantDashboard";


const commonDealerRoles = [
    roles.ADMIN,
    roles.BACKOFFICE,
    roles.MARKETING,
    roles.AGENTE,
    roles.VENDITORE,
    roles.SERVICE,
    roles.DEALER
];

const TenantRouter = () => {
    const { path } = useRouteMatch();
    const { activeTenant } = useAuth0();

    if (!activeTenant) {
        return (
            <Alert color="danger" className="my-4 mx-4">
                <p>
                    <strong>Attenzione! Nessun Dealer selezionato.</strong>
                </p>
                <p>
                    <Link to={`/?from=${window.location.pathname}`}>
                        Selezionare e assegnare un Dealer
                </Link>{" "}
                    per proseguire{" "}
                </p>
            </Alert>
        );
    }

    return (
        <Switch>
            <PrivateRoute
                key="dashboard"
                path={`${path}/dashboard`}
                exact
                activeTenant={activeTenant}
                component={() => <h3>Tenant dashboard here... work in progress.</h3>}
                roles={[roles.ADMIN, roles.DEALER, roles.AGENTE, roles.VENDITORE]}
            />
            <PrivateRoute
                key="structure"
                path={`${path}/structure`}
                exact
                activeTenant={activeTenant}
                roles={commonDealerRoles}
                component={TenantHierarchy}
            />
            <PrivateRoute
                key="orders"
                path={`${path}/orders`}
                exact
                activeTenant={activeTenant}
                roles={[roles.AGENTE, roles.ADMIN, roles.BACKOFFICE, roles.DEALER]}
                component={OrderList}
            />
            <PrivateRoute
                key="createOrder"
                path={`${path}/add-order`}
                exact
                activeTenant={activeTenant}
                roles={[roles.ADMIN, roles.DEALER]}
                component={OrderEditor}
            />
            <PrivateRoute
                key="editOrder"
                path={`${path}/orders/:id`}
                exact
                roles={[roles.ADMIN, roles.DEALER, roles.AGENTE, roles.BACKOFFICE]}
                component={OrderEditor}
            />
            <PrivateRoute
                key="editOrder"
                path={`${path}/orders/view-delivery/:id`}
                exact
                roles={[roles.ADMIN, roles.DEALER]}
                component={OrderDelivery}
            />
            <PrivateRoute
                key="storage"
                path={`${path}/storage`}
                exact
                activeTenant={activeTenant}
                roles={[roles.AGENTE, roles.ADMIN, roles.BACKOFFICE, roles.DEALER]}
                component={Storage}
            />
            <PrivateRoute
                key="customers"
                path={`${path}/customers`}
                exact
                activeTenant={activeTenant}
                returnTo={getUrlParameter("returnTo")}
                roles={[roles.ADMIN, roles.VENDITORE, roles.DEALER, roles.BACKOFFICE, roles.SERVICE, roles.MARKETING]}
                component={CustomersList}
            />
            <PrivateRoute
                key="customeradd"
                path={`${path}/add-customer`}
                exact
                activeTenant={activeTenant}
                returnTo={getUrlParameter("returnTo")}
                //category="privato"
                roles={[roles.ADMIN, roles.VENDITORE, roles.DEALER, roles.BACKOFFICE]}
                component={CustomerEditor}
            />
            <PrivateRoute
                key="customeredit"
                path={`${path}/customers/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.ADMIN, roles.VENDITORE, roles.DEALER, roles.BACKOFFICE, roles.MARKETING, roles.SERVICE]}
                component={CustomerEditor}
            />
            <PrivateRoute
                key="customerAddVehicle"
                path={`${path}/customers/:customer_id/add-vehicle/manually`}
                exact
                activeTenant={activeTenant}
                roles={commonDealerRoles}
                component={VehicleEditor}
            />
            <PrivateRoute
                key="customerAddVehiclePlate"
                path={`${path}/customers/:customer_id/add-vehicle/from-plate`}
                exact
                fromPlate
                activeTenant={activeTenant}
                roles={commonDealerRoles}
                component={VehicleEditor}
            />
            <PrivateRoute
                key="editVehicle"
                path={`${path}/vehicles/:id`}
                exact
                activeTenant={activeTenant}
                roles={commonDealerRoles}
                component={VehicleEditor}
            />
            <PrivateRoute
                key="products"
                path={`${path}/products`}
                exact
                activeTenant={activeTenant}
                roles={[roles.ADMIN]}
                component={ProductList}
            />
            <PrivateRoute
                key="productsedit"
                path={`${path}/products/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.ADMIN]}
                component={ProductEditor}
            />
            <PrivateRoute
                key="productview"
                path={`${path}/products-view/:id`}
                exact
/*                 readOnly
 */                activeTenant={activeTenant}
                roles={[roles.ADMIN]}
                component={ProductEditor}
            />
            <PrivateRoute
                key="productadd"
                path={`${path}/products-add`}
                exact
                activeTenant={activeTenant}
                roles={[roles.ADMIN]}
                component={ProductEditor}
            />
            <PrivateRoute
                key="sales"
                path={`${path}/sales`}
                exact
                activeTenant={activeTenant}
                roles={[roles.VENDITORE, roles.DEALER, roles.ADMIN, roles.AGENTE, roles.BACKOFFICE, roles.MARKETING]}
                component={SalesList}
            />
            <PrivateRoute
                key="addSale"
                path={`${path}/sales-add`}
                exact
                activeTenant={activeTenant}
                roles={[roles.VENDITORE, roles.DEALER, roles.ADMIN]}
                component={SaleEditor}
            />
            <PrivateRoute
                key="editSale"
                path={`${path}/sales/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.VENDITORE, roles.DEALER, roles.ADMIN, roles.AGENTE, roles.BACKOFFICE, roles.MARKETING]}
                component={SaleEditor}
            />
            <PrivateRoute
                key="saledoc"
                path={`${path}/sales/doc/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.VENDITORE, roles.DEALER, roles.ADMIN, roles.AGENTE, roles.BACKOFFICE, roles.MARKETING]}
                component={SaleDoc}
            />
            <PrivateRoute
                key="services"
                path={`${path}/services`}
                exact
                activeTenant={activeTenant}
                roles={[roles.SERVICE, roles.DEALER, roles.ADMIN]}
                component={ServicesList}
            />
            <PrivateRoute
                key="richiami"
                path={`${path}/service-notifications`}
                exact
                activeTenant={activeTenant}
                roles={[roles.SERVICE, roles.DEALER, roles.ADMIN]}
                component={ServiceNotificationList}
            />
            <PrivateRoute
                key="richiamiedit"
                path={`${path}/service-notifications/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.SERVICE, roles.DEALER, roles.ADMIN]}
                component={ServiceNotificationEditor}
            />
            <PrivateRoute
                key="addService"
                path={`${path}/services-add`}
                exact
                activeTenant={activeTenant}
                roles={[roles.SERVICE, roles.DEALER, roles.ADMIN]}
                component={ServicesEditor}
            />
            <PrivateRoute
                key="editService"
                path={`${path}/services/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.SERVICE, roles.DEALER, roles.ADMIN]}
                component={ServicesEditor}
            />
            <PrivateRoute
                key="viewservice"
                path={`${path}/services-view/:id`}
                exact
                readOnly
                activeTenant={activeTenant}
                roles={[roles.SERVICE, roles.DEALER, roles.ADMIN]}
                component={ServicesEditor}
            />
            <PrivateRoute
                key="marketing"
                path={`${path}/marketing`}
                exact
                activeTenant={activeTenant}
                roles={[roles.MARKETING, roles.DEALER, roles.ADMIN]}
                component={MarketingList}
            />
            <PrivateRoute
                key="addMarketing"
                path={`${path}/marketing-add/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.MARKETING, roles.ADMIN]}
                component={MarketingEditor}
            />
            <PrivateRoute
                key="editmarketing"
                path={`${path}/marketing/:id`}
                exact
                activeTenant={activeTenant}
                roles={[roles.MARKETING, roles.ADMIN]}
                component={MarketingEditor}
            />
            <PrivateRoute
                key="emaileditor"
                path={`${path}/emaileditor`}
                exact
                activeTenant={activeTenant}
                roles={commonDealerRoles}
                component={EmailsEditor}
            />
        </Switch>
    );
};

export default TenantRouter;